import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { tap, map } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { environment } from '../../environments/environment';
import { LoggingService } from '../shared/services/logging/logging.service';
import { IUserAccess } from '../user-info/store/user.reducer';
import { IUserInfo } from './IUserInfo';
import * as fromUser from '../user-info/store/user.reducer';
import { select, Store } from '@ngrx/store';
import { UserRoleComponent } from '../user-role/user-role.component';
import { IUserColor } from './IUserColor';
import moment from 'moment';
@Injectable({
    providedIn: 'root'
})
export class UserInfoService {
    public userRoleComponent: UserRoleComponent;
    private userSub: Subscription;
    public userInfo: IUserInfo;
    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(LoggingService) private log: LoggingService
    ) {}

    public get(): Observable<IUserAccess> {
        const url = `${environment.apiLocation}/Main`;

        return this.http.get<IUserAccess>(url).pipe(
            tap(res =>
                this.log.verbose({
                    type: 'UserInfoService:get:reponse',
                    res
                })
            )
        );
    }

    public getUserInfo(): Observable<IUserInfo> {
        const url = `${environment.apiLocation}/UserInfo`;
        return this.http.get<Array<IUserInfo>>(url).pipe(
            tap(data =>
                this.log.verbose({
                    type: 'UserInfoService:getUserInfo:reponse',
                    data
                })
            ),
            map(x => x[0]),
            map(x => ({
                ...x,
                CurrentPayPeriodStart: moment(x.CurrentPayPeriodStart).toDate(),
                CurrentPayPeriodEnd: moment(x.CurrentPayPeriodEnd).toDate(),
                FYStartDate: moment(x.FYStartDate).toDate(),
                FYEndDate: moment(x.FYEndDate).toDate(),
                PrevPayPeriodStart: moment(x.PrevPayPeriodStart).toDate(),
                PrevPayPeriodEnd: moment(x.PrevPayPeriodEnd).toDate(),
                UserEntryStartDate: moment(x.UserEntryStartDate).toDate(),
                UserEntryEndDate: moment(x.UserEntryEndDate).toDate()
            }))
        );
    }
    public getUserColors(
        EmployeeListID: string
    ): Observable<Array<IUserColor>> {
        const url = `${environment.apiLocation}/UserWebColor`;
        this.log.verbose({
            type: 'UserInfoService:getUserColors',
            EmployeeListID
        });
        return this.http
            .post<Array<IUserColor>>(url, { EmployeeListID: EmployeeListID })
            .pipe(
                tap(data =>
                    this.log.verbose({
                        type: 'UserInfoService:getUserColors:reponse',
                        data
                    })
                )
            );
    }
}
